import '../scss/main.scss';

import Flickity from 'flickity';
import 'flickity/dist/flickity.css';

window.addEventListener('DOMContentLoaded', () => {
	let columnCarouselContainers = document.querySelectorAll('.columns-wrapper.columns-carousel-view');

	if (columnCarouselContainers.length < 1) {
		return;
	}

	columnCarouselContainers = [].slice.call(columnCarouselContainers);

	columnCarouselContainers.forEach(container => {
		new Flickity(container, {
			contain: true,
			pageDots: false,
			prevNextButtons: true,
			autoPlay: false,
			wrapAround: false,
			cellAlign: 'center'
		});
	});
});